/**
 * Operation name of layer.counts.query.gql. Every mutation that changes a
 * layer's IsEnabled or review state refetches it so the page tabs,
 * status-filter pills, and sidebar badge stay accurate.
 */
export const LAYER_COUNTS_QUERY_NAME = "LayerCountsQuery"

/** Numeric ids the layers status-filter chips assign to the Enabled/Disabled pills. */
export const LAYER_ENABLED_STATUS_CODE = 0
export const LAYER_DISABLED_STATUS_CODE = 1
